<template>
    <div style="overflow: auto;height: 100vh;">
        <div class="horizonal-tab">
            <van-tabs v-model="current" @click="onClickItem">
                <van-tab :title="value.name" :name="value.id" v-for="(value, index) in items " :key="index">
                </van-tab>
            </van-tabs>
        </div>
        <div class="inesli" v-if="ceditCardlist.length > 0">
            <div v-for="(item, index) in ceditCardlist" class="conten" :key="index" @click="extrnsion(item.creditId)">
                <div class="conteli">
                    <div
                        :class="item.status == 1 ? 'inescole' : (item.status == 2 ? 'inescoleblue' : (item.status == 4 ? 'inescolebluet' : 'inescolexin'))">
                        {{ item.status == 1 ? '强烈推荐' : (item.status == 2 ? '热门' : (item.status == 4 ? '通过率高' :
                            '最新')) }}
                    </div>
                </div>
                <div class="inesimg">
                    <img :src="item.icon" />
                </div>
                <!-- bug#1771: 资源名称分行显示 -->
                <div class="spname" :style="{ '--bar-width': boxSize + 'px', 'height': '50px' }"
                    :class="(emSize * (item.name.match(/[^\u4e00-\u9fa5]/g) || []).length / 1.8) + (emSize * (item.name.match(/[\u4e00-\u9fa5]/g) || []).length) >= boxSize ? '' : ''">
                    {{ item.name.toString() }}</div>
                <!-- spname :class 1(em2px) *不包括中文的字符宽度（非中文字符0.5em） + 1(em2px) 中文字符的宽度  = name的宽度 > 盒子的宽度 ？ 添加动画 ： ‘’-->
                <div class="uni-flex ineslable" :class="{ center: item.labels.length < 2 }">
                    <div :class="index == 1 ? 'lableis' : 'lablei'" v-for="(item, index) in item.labels" :key="index">
                        {{ item }}
                    </div>
                </div>
                <div v-if="item.code != 'CMBC100EHPQ'" class="lospen">{{ item.remarks }}</div>
                <div v-else style="color: orange;" class="lospen">{{ item.remarks }}</div>

                <div class="uni-flex insetomm">
                    <!-- 	<view class="tommle">奖</view> -->
                    <img :src="`http://app.yhbzf.com:7777/group1/M00/00/04/rB3g-WGV6dmAWYi0AAAOC8fUh7s423.png`" />
                    <div v-if="item.code != 'CMBC100EHPQ'" class="miey">￥{{ item.commission }}</div>
                    <div v-else class="miey" style="color: yellow;">￥{{ item.commission }}</div>
                </div>
                <!-- <view class="liji">立即推广</view> -->
            </div>
        </div>
        <div class="pagesli" v-else>
            <img class="pagesli" src="../../assets/activityUrl/nodata.jpg" mode="widthFix" />
        </div>
    </div>
</template>
<script>
import { formatDateTime } from '../../utils/core.js';
import { getParticipationCreditList, getCreditTypeList, getDataList, getActivityEntry } from '@/api/index';
export default {
    data() {
        return {
            activityId: null,
            emSize: 0, // spname 一个字体的宽度
            boxSize: 0,	// 一个 conten 的宽度
            current: 0, //列表切换
            currentIndex: 0, //列表索引
            items: [], //资源列表
            swiperheight: 500,
            ceditCardlist: [], //信用卡列表
            typeId: 0, //资源ID
            // url: 'http://app.yhbzf.com:7777/group1/M00/00/04/rB3g-WGV6dmAWYi0AAAOC8fUh7s423.png'
            activityData: {},
            activity: null,
            currentActivityId: null, // 第一条活动
        }

    },
    created() {
        this.activityId = this.$route.query.activityId
        this.activityStatus = this.$route.query.status
        getCreditTypeList(this.$store.getters.getToken).then(res => {
            if (res.code == 200) {
                this.items = res.data.filter(value => value.id != 6) // 过滤信贷

                // if (option?.typeId) {
                //     let index = this.items.findIndex(item => item.id == option.typeId);

                //     if (index !== -1) this.onClickItem({
                //         currentIndex: index
                //     })
                // }
                // 获取银行卡列表
                this.getdata()

            }
        });
    },
    methods: {
        formatDateTime,
        // 信用卡活动跳转
        activitySkip() {
            if (this.currentActivityId) {
                this.$router.push({ path: '/activityDetail', query: { id: this.currentActivityId, dataType: 0 } });
            } else {
                this.$router.push({ path: '/activity', query: { enrce: this.activityData.id, dataType: 0 } });
            }
        },
        getdata() {
            let data = {
                typeId: this.typeId,
                activityId: this.activityId
            }
            getParticipationCreditList(data, this.$store.getters.getToken).then((res) => {
                if (res.code == 200) {
                    this.ceditCardlist = res.data.rows.filter(item => item.type == 0);

                    if (this.typeId == 7) {
                        if (res.data.rows.length > 0) {
                            this.activity = res.data.extraData
                        } else {
                            this.activity = {
                                noDataImg: res.data.extraData
                            }
                        }
                    } else {
                        this.activity = res.data.extraData
                    }
                }

            })
        },
        // 活动入口
        getActivityData() {
            let newdata = {
                dataType: 0
            }
            getActivityEntry(newdata, this.$store.getters.getToken).then((res) => {
                if (res.code == 200) {
                    this.activityData = res.data
                }
            })
            // 数据列表
            getDataList(
                1, 10,
                newdata, this.$store.getters.getToken
            )
                .then((res) => {
                    if (res.code == 200) {
                        let arr = []
                        arr = res.data.rows
                        if (arr.length == 1) {
                            this.currentActivityId = arr[0].id
                        } else {
                            this.currentActivityId = null
                        }
                    }
                });
        },
        //切换选项卡
        onClickItem(e) {
            if (this.currentIndex == e) {
                return
            }
            this.currentIndex = e
            this.typeId = e
            this.getdata()
        },
        //申卡订单入口
        orderEntry() {
            this.$router.push({ path: '/cardapplication' });
        },
        // 跳转资源详情
        extrnsion(creditId) {
            this.$router.push({ path: '/extension', query: { creditId: creditId } });
        },
    }
}
</script>
<style lang="scss" scoped>
.inesli {
    width: 99%;
    margin: auto;
    flex-wrap: wrap;
    display: flex;

    .inesimg {
        width: 100%;
        height: 45px;
        margin-top: 2px;

        img {
            width: 45px !important;
            height: 45px;
            // border-radius: 50%;
        }
    }

    .inescole {
        font-size: 8px;
        background-color: red;
        background-image: linear-gradient(to right, orange, red);
        color: #FFFFFF;
        // width: 100rpx;
        padding: 2px 6px;
        border-radius: 7.5px;
        margin-top: 2px;
        margin-left: 4px;
        white-space: pre;
    }

    .inescoleblue {
        font-size: 8px;
        background-color: #33C4FF;
        background-image: linear-gradient(to right, #359aff, #33c6ff);
        color: #FFFFFF;
        // width: 100rpx;
        padding: 2px 6px;
        border-radius: 7.5px;
        margin-top: 2px;
        margin-left: 4px;
    }

    .inescolebluet {
        font-size: 8px;
        background-color: #33C4FF;
        background-image: linear-gradient(to right, orange, #33c6ff);
        color: #FFFFFF;
        // width: 100rpx;
        padding: 2px 6px;
        border-radius: 7.5px;
        margin-top: 2px;
        margin-left: 4px;
    }

    .inescolexin {
        font-size: 8px;
        background-color: orange;
        background-image: linear-gradient(to right, yellow, orange);
        color: #FFFFFF;
        // width: 60rpx;
        padding: 2px;
        border-radius: 7.5px;
        margin-top: 2px;
        margin-left: 4px;
    }

    .conten {
        width: 32%;
        // height: 470rpx;
        padding-bottom: 20px;
        text-align: center;
        background-color: #FFFFFF;
        border-radius: 10px;
        margin-top: 3%;
        margin-left: 1%;
        position: relative;
        overflow: hidden;

        .conteli {
            width: 45%;
            text-align: center;
            margin-bottom: 4px;
        }

        .spname {
            font-weight: bold;
            line-height: 25px;
            letter-spacing: 0.5px;
            margin-top: 10px;
            font-size: 15px;
            display: -webkit-box;
            padding: 0 5px;
            overflow: hidden;
            /* 创建一个弹性容器盒子模型 */
            -webkit-box-orient: vertical;
            /* 设置盒子的排列方向为垂直 */
            -webkit-line-clamp: 2;
            /* 限制在3行内 */
            word-break: break-all;
            /* 允许在单词内换行 */
        }

        .spname-new {
            font-weight: bold;
            line-height: 25px;
            letter-spacing: 0.5px;
            margin-top: 10px;
            font-size: 15px;
        }

        .ineslable {
            display: flex;
            font-size: 9px;
            justify-content: space-between;
            width: 99%;
            margin: auto;
            margin-top: 10px;

            .lablei {
                border: 1px solid red;
                padding: 2.5px;
                color: red;
                width: 44%;
                height: 15px;
                line-height: 15px;
                white-space: pre;
            }

            .lableis {
                border: 1px solid blue;
                padding: 2.5px;
                color: blue;
                width: 44%;
                height: 15px;
                line-height: 15px;
                white-space: pre;
            }

            .lableblue {
                border: 1px solid blue;
                padding: 2.5px;
                color: blue;
                width: 42%;
            }

            &.center {
                justify-content: center;
            }
        }

        .lospen {
            font-size: 10px;
            line-height: 20px;
            width: 96%;
            margin: auto;
            margin-top: 10px;
            height: 40px;
            color: #484848;
            overflow: hidden; //超出文本隐藏
            text-overflow: ellipsis; ///超出部分省略号显示
            display: -webkit-box; //弹性盒模型
            -webkit-box-orient: vertical; //上下垂直
            -webkit-line-clamp: 2; //自定义行数
        }

        .insetomm {
            width: 90%;
            height: 22.5px;
            line-height: 22.5px;
            margin: auto;
            background-color: #fa4f5f;
            border-radius: 25px;
            margin-top: 5%;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                width: 15px;
                height: 15px;
            }

            // .tommle {
            // 	width: 55rpx;
            // 	height: 55rpx;
            // 	line-height: 55rpx;
            // 	background-color: #fa4f5f;
            // 	color: #FFE126;
            // 	border-radius: 50%;
            // 	border-right: 2rpx solid #FFFFFF;
            // 	padding: 0 5rpx 0 5rpx;
            // }

            .miey {
                color: #FFFFFF;
                font-size: 11px;
                letter-spacing: 0.5px;
                // font-weight: bold;
                // margin-left: 10rpx;
            }
        }

        .liji {
            line-height: 30px;
            background-color: #CF142B;
            color: #FFFFFF;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
            position: absolute;
            bottom: 0;
            width: 100%;
        }
    }
}


.anim {
    white-space: nowrap;
    display: inline-block;
    animation: 5s wordsLoop linear infinite alternate;

}

.wrapper {
    background-size: 100% auto;
    background-repeat: no-repeat;
}

.activity-header {
    text-align: center;

    &-title {
        font-size: 24px;
        text-shadow: 0 2px 0 #9C1717;
        color: #ffffff;
        text-align: center;
        padding: 60px 30px 0;
        line-height: 34px;
        margin-bottom: 14px;
    }

    &-sub {
        color: #FFFFFF;
        line-height: 19px;
        padding: 2px 16px 4px;
        display: inline-block;
        margin: 0 auto 20px;
        font-size: 14px;
        border-radius: 12.5px;
        border: 1px solid #FFFFFF;
    }
}

.activity-footer {
    &-title {
        font-size: 24px;
        color: #ffffff;
        text-align: center;
        padding-top: 6px;
        line-height: 34px;
        margin-bottom: 10px;
    }

    &-rule {
        // min-height: 210rpx;
        margin: 20rpx 32rpx;
        background-color: rgba(#FFFFFF, .15);
        border-radius: 6rpx;
        font-size: 26rpx;
        color: #FFFFFF;
        line-height: 36rpx;
        padding: 24rpx 20rpx;
    }

    &-copyright {
        color: #FFEBB6;
        font-size: 28rpx;
        text-align: center;
        margin-bottom: 54rpx;
    }
}

.active-noData {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 156rpx;

    &-img {
        width: 300rpx;
        display: inline-block;
        margin-bottom: 56rpx;
    }

    &-text {
        font-size: 30rpx;
        font-weight: 400;
        color: #999999;
        line-height: 60rpx;
        margin-bottom: 20rpx;
    }

    &-sub {
        font-size: 30rpx;
        font-weight: 400;
        color: #333333;
        line-height: 60rpx;
    }
}


@keyframes wordsLoop {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(calc(var(--bar-width) - 100%));
    }

}

.ActivitySyn {
    height: 60px;
    position: relative;
}

.activity-name {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80%;
    text-align: center;
    transform: translate(-50%, -50%);
    font-size: 22px;
    font-family: HarmonyOS_Sans_SC_Black;
    color: #FFFFFF;
}

.activity-image {
    width: 100%;
    height: 56px;
}

.activity-path {
    width: 6px;
    height: 10px;
    position: absolute;
    top: 50%;
    right: 4%;
    transform: translate(-50%, -50%);
}

.pagesli {
    height: 100vh;
    width: 100vw;
    text-align: center;
    background: #ffffff;
}
</style>